import {
    getCachedTableDataSlice,
    getCachedTableResultSelector,
} from 'src/hooks/common-data-service/cached-table';

import {datasetEntitlementsStateSelector} from './dataset-entitlements-state.slice';

import type {
    CachedTableCacheSelector,
    CachedTableDataSelector,
} from 'src/hooks/common-data-service/cached-table/typedef';
import type {EntitlementsFilters, ResourceView} from 'src/modules/entitlements/typedef';

export const datasetEntitlementsSlice = getCachedTableDataSlice<
    ResourceView[],
    undefined,
    undefined,
    EntitlementsFilters
>('datasetEntitlements');

export const datasetEntitlementsActions = datasetEntitlementsSlice.actions;
const datasetEntitlementsCacheSelector: CachedTableCacheSelector<ResourceView[]>
    = state => state.manageEntitlements.datasetEntitlementsReducer.entitlements.cache;
export const datasetEntitlementsDataSelector: CachedTableDataSelector<ResourceView[]>
    = state => state.manageEntitlements.datasetEntitlementsReducer.entitlements;
export const datasetEntitlementsResultSelector = getCachedTableResultSelector(
    datasetEntitlementsCacheSelector,
    datasetEntitlementsStateSelector,
);
